// extracted by mini-css-extract-plugin
module.exports = {"btn":"RotatingButton_btn__6fnMz","root":"RotatingButton_root__iXZpI"};